import $ from 'jquery';
import WOW from 'wow.js';

export const init = () => {

	let wow = new WOW(
		{
			boxClass: 'wow',      // default
			animateClass: 'animated', // default
			offset: 0,          // default
			mobile: true,       // default
			live: true        // default
		}
	)
	wow.init();

	$('.b-gallery--wow').addClass('wow--ready');

};
